import { Alert, Avatar, Backdrop, Box, Button, ButtonGroup, CircularProgress, IconButton, Paper, Snackbar, Stack, TextField, Typography } from "@mui/material";
import { SchoolInfo } from "../../redux/school/schoolSlice";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/user/userSlice";
import { retrieveSchoolStudents, RetrieveSchoolStudentsRequest, schoolStudentsSlice, selectSchoolStudents } from "../../redux/school/schoolStudentsSlice";
import { useAppDispatch } from "../../app/hooks";
import { assertThumbnailUrl, LoadState } from "../../redux/common";
import { isTokenReady } from "../user/UserAvatar";
import { useEffect, useState } from "react";
import { stringAvatar, stringToColor } from "../user/avatarUtils";
import { studentDisplayName, StudentInfo } from "../../redux/student/studentSlice";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import { ConversationCreateRequest, conversationCreateSlice, performConversationCreate, selectConversationCreate } from "../../redux/conversation/conversationCreateSlice";
import { ObjectTarget } from "../../app/permissions";
import { ConversationType } from "../../redux/conversation/conversationSlice";
import { ClassroomInfo } from "../../redux/classroom/classroomSlice";
import { classroomStudentsSlice, retrieveClassroomStudents, RetrieveClassroomStudentsRequest, selectClassroomStudents } from "../../redux/classroom/classroomStudentsSlice";
import { NamedObject } from "../../redux/object/namedObject";
import { DptoInfo } from "../../redux/dpto/dptoSlice";

interface ContactAddProps {
    me: NamedObject;
    school: SchoolInfo;
    classroom?: ClassroomInfo;
    dpto?: DptoInfo;
    height: number;
    // select: (c: ConversationInfo) => void;
    clickReturn: () => void;
}

export const ContactAdd = (props: ContactAddProps) => {
    const user = useSelector(selectUser);
    const conversationCreate = useSelector(selectConversationCreate);
    const dispatch = useAppDispatch();
    const [filterContact, setFilterContact] = useState("");

    const schoolStudents = useSelector(selectSchoolStudents);
    const classroomStudents = useSelector(selectClassroomStudents);

    useEffect(() => {
        if (props.classroom) {
            const request: RetrieveClassroomStudentsRequest = { schoolId: props.school.id, classroomId: props.classroom.id };
            dispatch(classroomStudentsSlice.actions.check(request));
            if (classroomStudents.state.state == LoadState.NotStarted && isTokenReady(user)) {
                dispatch(retrieveClassroomStudents(request));
            }
        } else {
            const request: RetrieveSchoolStudentsRequest = { schoolId: props.school.id, classroomId: undefined, filter: filterContact };
            dispatch(schoolStudentsSlice.actions.check(request));
            if (schoolStudents.state.state == LoadState.NotStarted && isTokenReady(user)) {
                dispatch(retrieveSchoolStudents(request));
            }
        }
    }, [schoolStudents, classroomStudents, user, props.school.id, filterContact]);

    useEffect(() => {
        if (conversationCreate.state.state == LoadState.Loaded) {
            dispatch(conversationCreateSlice.actions.clean());
            // props.select(conversationCreate.response!);
            props.clickReturn();
        }
    }, [conversationCreate]);

    const topHeight = props.classroom ? 46 : 96;
    const messageHeight = props.height - topHeight;

    const createContact = (student: StudentInfo) => {
        console.log("Create contact", student);
        const request: ConversationCreateRequest = {
            conversationType: ConversationType.DUAL_PARTY,
            parties: [
                { objectTarget: ObjectTarget.STUDENT, targetId: student.id },
                { objectTarget: props.me.type, targetId: props.me.targetId }
            ]
        };
        dispatch(performConversationCreate(request));
    };

    const avatarSize = 56;
    const options = () => {
        const list = ( props.classroom 
            ? classroomStudents.list 
            : schoolStudents.list ) || [];

        if (list.length == 0) {
            return <Typography variant="h6" sx={{ padding: 2 }}>Nenhum contato encontrado</Typography>;
        }

        return list.map((student) => {
            const name = studentDisplayName(student);
            const image = assertThumbnailUrl(student.url);
            return <Stack key={`contact-option-${student.id}`} direction="row" spacing={0}
                sx={{ border: "1px solid gray", padding: 1, margin: 1, borderRadius: 4 }}>
                <Box sx={{ width: avatarSize, height: avatarSize, alignContent: "center", justifyContent: "center", justifyItems: "center" }}>
                    <Avatar sx={{ width: avatarSize, height: avatarSize, m: 0, border: "1px solid gray", backgroundColor: stringToColor(name) }}
                        variant='circular' alt={`${name}`} src={image}>
                        <Typography variant="h6" component="span">
                            {stringAvatar(name)}
                        </Typography>
                    </Avatar>
                </Box>
                <Typography variant="h6"
                    sx={{
                        width: "100%", textWrap: "nowrap", textOverflow: "ellipsis", overflow: "hidden",
                        justifyContent: "center", alignContent: "center", justifyItems: "left", textAlign: "left",
                        paddingX: 2
                    }}>
                    {name}
                </Typography>
                <Box sx={{
                    justifyContent: "center", alignContent: "center",
                    paddingRight: 1, marginY: 1
                }}>
                    <ButtonGroup variant="contained" color="primary" size='small'
                        sx={{ height: "100%", justifyContent: "center", alignContent: "center" }}>
                        <Button onClick={() => createContact(student)}>
                            <AddIcon />
                        </Button>
                    </ButtonGroup>
                </Box>
            </Stack>;
        });
    };

    const filerContacts = (e: any) => {
        setFilterContact(e.target.value);
    };

    const dismissError = () => {
        dispatch(conversationCreateSlice.actions.clean());
    };

    return <>
        <Paper key={"contact-add-paper"} elevation={3} sx={{ height: topHeight, borderRadius: 0, borderLeft: "1px black solid", backgroundColor: "#F8F8F8" }}>
            <Stack key={"contact-add-stack-row"} direction="row" spacing={0}>
                <Stack direction="column" spacing={0} sx={{ paddingY: 1, paddingX: 1, width: "100%" }}>
                    <Stack direction="row" spacing={2}>
                        <Typography variant="h6">Adicionar Contato</Typography>
                        <Box sx={{ flexGrow: 1 }} />
                        <IconButton
                            onClick={() => props.clickReturn()}
                            sx={{ width: "32px", height: "30px", borderRadius: "25%" }} size='small'>
                            <CancelIcon />
                        </IconButton>
                    </Stack>
                    {
                        !props.classroom &&
                        <Stack direction="row" spacing={2}>
                            <TextField size='small' id="outlined-basic" label="Pesquisar" variant="outlined" fullWidth
                                onChange={(e) => filerContacts(e)} />
                        </Stack>
                    }
                </Stack>
            </Stack>
        </Paper>
        <Box sx={{ padding: 0, border: "1px gray solid", /* backgroundColor: "red", */ height: messageHeight, overflowY: "scroll" }}>
            {options()}
        </Box>
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={conversationCreate.state.state == LoadState.Loading} >
            <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar open={conversationCreate.state.state == LoadState.Failed} autoHideDuration={5000} onClose={dismissError}>
            <Alert onClose={dismissError} severity="error" variant="filled" sx={{ width: "100%" }}> Erro ao criar conversa. </Alert>
        </Snackbar>
    </>;
};